import { AppConstants } from "../AppConstants";

const { Languages } = AppConstants.ImagePaths;

// Skills data (used by SkillBar-based Skills component — currently unused, kept for reference)
export const SkillData = [
  { label: "Java", icon: <img src={Languages.Java} alt="Java" loading="lazy" /> },
  { label: "HTML", icon: <img src={Languages.HTML} alt="HTML" loading="lazy" /> },
  { label: "CSS", icon: <img src={Languages.CSS} alt="CSS" loading="lazy" /> },
  { label: "SCSS", icon: <img src={Languages.SCSS} alt="SCSS" loading="lazy" /> },
  { label: "Tailwind CSS", icon: <img src={Languages.Tailwind} alt="Tailwind CSS" loading="lazy" /> },
  { label: "JavaScript", icon: <img src={Languages.JavaScript} alt="JavaScript" loading="lazy" /> },
  { label: "React.JS", icon: <img src={Languages.React} alt="React" loading="lazy" /> },
  { label: "Bootstrap", icon: <img src={Languages.Bootstrap} alt="Bootstrap" loading="lazy" /> },
  { label: "Material UI", icon: <img src={Languages.Material} alt="Material UI" loading="lazy" /> },
  { label: "Node.JS", icon: <img src={Languages.Node} alt="Node.js" loading="lazy" /> },
  { label: "Express.JS", icon: <img src={Languages.Express} alt="Express.js" loading="lazy" /> },
  { label: "MongoDB", icon: <img src={Languages.MongoDB} alt="MongoDB" loading="lazy" /> },
  { label: "MySQL", icon: <img src={Languages.MySQL} alt="MySQL" loading="lazy" /> },
  { label: "Firebase", icon: <img src={Languages.Firebase} alt="Firebase" loading="lazy" /> },
  { label: "Git", icon: <img src={Languages.Git} alt="Git" loading="lazy" /> },
  { label: "Github", icon: <img src={Languages.Github} alt="GitHub" loading="lazy" /> },
];

// Skills divided into categories (used by TempSkill component)
export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "HTML", icon: <img src={Languages.HTML} alt="HTML" loading="lazy" /> },
      { name: "CSS", icon: <img src={Languages.CSS} alt="CSS" loading="lazy" /> },
      { name: "SCSS", icon: <img src={Languages.SCSS} alt="SCSS" loading="lazy" /> },
      { name: "Tailwind CSS", icon: <img src={Languages.Tailwind} alt="Tailwind CSS" loading="lazy" /> },
      { name: "React Js", icon: <img src={Languages.React} alt="React" loading="lazy" /> },
      { name: "Material UI", icon: <img src={Languages.Material} alt="Material UI" loading="lazy" /> },
      { name: "Bootstrap", icon: <img src={Languages.Bootstrap} alt="Bootstrap" loading="lazy" /> },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Node Js", icon: <img src={Languages.Node} alt="Node.js" loading="lazy" /> },
      { name: "Express Js", icon: <img src={Languages.Express} alt="Express.js" loading="lazy" /> },
      { name: "Nest Js", icon: <img src={Languages.NestJS} alt="NestJS" loading="lazy" /> },
      { name: "Mongo DB", icon: <img src={Languages.MongoDB} alt="MongoDB" loading="lazy" /> },
      { name: "MySQL", icon: <img src={Languages.MySQL} alt="MySQL" loading="lazy" /> },
      { name: "Firebase", icon: <img src={Languages.Firebase} alt="Firebase" loading="lazy" /> },
    ],
  },
  {
    title: "Other",
    skills: [
      { name: "Java", icon: <img src={Languages.Java} alt="Java" loading="lazy" /> },
      { name: "JavaScript", icon: <img src={Languages.JavaScript} alt="JavaScript" loading="lazy" /> },
      { name: "TypeScript", icon: <img src={Languages.TypeScript} alt="TypeScript" loading="lazy" /> },
      { name: "Git", icon: <img src={Languages.Git} alt="Git" loading="lazy" /> },
      { name: "Github", icon: <img src={Languages.Github} alt="GitHub" loading="lazy" /> },
      { name: "Docker", icon: <img src={Languages.Docker} alt="Docker" loading="lazy" /> },
      { name: "AWS", icon: <img src={Languages.AWS} alt="AWS" loading="lazy" /> },
    ],
  },
];